// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JS Modules
import SummaryTable from '../common/summary-table';

const SummaryChart = ({ className, ...props }) => (
  <div className={classNames('summary-chart', className)}>
    <h6>Your Print Order</h6>
    <SummaryTable {...props} />
  </div>
);

export default SummaryChart;
